<template>
  <div class="animated fadeIn listkirimanretur">
    <b-card>
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:90px !important;">Nomor Retur</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.no_return" ></b-form-input>              
            <b-input-group-prepend>
              <label style="width:90px !important;text-align:right;">Jenis Kiriman</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.customer_group" :plain="true" :options="customer_group" style="width:8% !important;"></b-form-select>
            <b-input-group-prepend>
              <label style="width:90px !important;text-align:right;">Kota Layanan</label>
            </b-input-group-prepend>
            <b-form-input style="width:13% !important;"
              v-model="tblData.kota_name"
              @keyup.13.native="lkuKoranKotaShow=true"
              @change="tblData.kota_id=''"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuKoranKotaShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width:90px !important;">Customer</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.CustName"
              @keyup.13.native="lkuKoranCustShow=true"
              @change="tblData.customer_id=''"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranCustShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-input-group-prepend>
                <span class="p-2">Nama AE/MA</span>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.salesae_name" placeholder="Sales (AE)" @change="tblData.salesid_id=''"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button"  @click="lkuKoranSalesShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:90px !important;">Tgl.Retur</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tglR1" type="date" placeholder="from date"></b-form-input>
            <b-input-group-append>
              <span class="input-group-text">s.d.</span>
            </b-input-group-append>
            <b-form-input v-model="tblData.tglR2" type="date" placeholder="until date"></b-form-input>
            <b-input-group-append>
              <b-button class="btn btn-success ml-1" style="width:110px" @click="search()">
                <i class="fa fa-refresh"></i> Apply Filter
              </b-button>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:90px !important;">Tgl/Edisi</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date" placeholder="from date"></b-form-input>
            <b-input-group-append>
              <span class="input-group-text">s.d.</span>
            </b-input-group-append>
            <b-form-input v-model="tblData.tgl2" type="date" placeholder="until date"></b-form-input>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" style="width:110px"  @click="clearFilter()">
                <i class="fa fa-eraser"></i> Clear Filter
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>

      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        small
        style="font-size:smaller;"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
        @row-dblclicked="edit()"
        show-empty
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>        
        <template v-slot:cell(tglretur)="data">
          {{ data.item.tglretur | moment("DD MMM YYYY") }}
        </template>        
        <template v-slot:cell(pickupdate)="data">{{ data.item.pickupdate | moment('YYYY-MM-DD') }}</template>
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>        
        <template v-slot:cell(CustName)="data">{{ data.item.CustCode+' | '+ data.item.CustName }}</template>
        <!-- <template v-slot:cell(Address)="data">
          {{ data.item.Address1 }}
          {{ data.item.Address2 }}
        </template> -->
        <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
          <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-input-group style="width: 200px;">
              <b-input-group-prepend class="mb-0"><span class="p-2">Limit per page</span></b-input-group-prepend>
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
            </b-input-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-col md="5" lg="4" xl="3">
          <b-input-group>
                <b-input-group-prepend><span class="input-group-text">TOTAL Retur</span></b-input-group-prepend>              
                <b-form-input :value="tblData.retur_qty | numFormat" readonly class="text-right font-weight-bold"></b-form-input>
                <b-input-group-prepend><span class="input-group-text">Eksemplar</span></b-input-group-prepend>                 
          </b-input-group>
        </b-col>
        <b-col md="6" lg="4" xl="3">
         <b-input-group>
            <b-input-group-prepend><span class="input-group-text">NILAI Retur</span></b-input-group-prepend>              
            <b-form-input :value="tblData.retur_val | numFormat('0,0.00')" readonly class="text-right font-weight-bold"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">{{uanguser}}</span></b-input-group-prepend>              
        </b-input-group>
        </b-col>
      </b-row>

    </b-card>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 bundle retur nomor {{model.no_return}} akan dihapus</p>
        <p class="font-weight-bold m-0 text-danger">Apakah proses akan dilanjutkan </p>
      </b-modal>
    <b-modal v-model="lkuKoranCustShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
      <lku-customerkoran @click="onSelectKoranCust" customer_group='KORAN'></lku-customerkoran>
    </b-modal>
    <b-modal v-model="lkuKoranKotaShow" size="lg" :hide-footer="true" title="List Kota" :centered="true">
      <lku-kota @click="onSelectKota"></lku-kota>
    </b-modal>
    <!-- <b-modal v-model="lkuKoranJurusanShow" size="lg" :hide-footer="true" title="List Jurusan" :centered="true">
      <lku-jurusan @click="onSelectJurusan"></lku-jurusan>
    </b-modal> -->
      <b-modal v-model="lkuKoranSalesShow" size="lg" :hide-footer="true" title="List Sales" :centered="true">
        <lku-salesae @click="onSelectKoranSales" crudfilter="koran=1"></lku-salesae>
      </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>

<style lang="scss">
  .listkirimanretur {
    table {
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
}
</style>
<script>
import moment from "moment";
import Loading from "vue-loading-overlay";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import koran_kiriman from "../../apis/koran_kiriman_retur";
import lkuSalesae from "../lookup/lkuSalesae";
import lkuCustomerkoran from "../lookup/lkuKoranCust";
import lkuKota from "../lookup/lkuKoranKota";


toastr.init();

export default {
  components: { Loading, lkuCustomerkoran, lkuSalesae, lkuKota },
  mixins: [validationMixin],
  validations: {
    frmdata: {
      kota_name: { required },
      area_id: { required }
    }
  },
  data() {
    return {
      isLoading: false,
      showFilter: false,
      showDelConfirm: false,
      lkuKoranCustShow: false,
      lkuKoranSalesShow: false,
      lkuKoranKotaShow: false,
      lkuKoranJurusanShow: false,
      lkuKoranCollectShow: false,
      // tglaktif: moment().subtract(5,'days').format('YYYY-MM-DD'),
      tglaktif: this.$store.state.user.tglkoran,
      uanguser: this.$store.state.user.matauang,
      model:{},
      pagination: false,      
      limit:15,
      tblData: {
        // tablename: "vwkorankota",
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tglretur",
        sortDesc: false,
        customer_group: null
      }
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
        {
          key: "tglretur",
          label: "Tanggal Retur",
          sortable: true
        },
        {
          key: "no_return",
          label: "No Retur",
          sortable: true
        },
        {
          key: "pickupdate",
          label: "Tgl. Pengambilan",
          sortable: true
        },
        {
          key: "tanggal",
          label: "Tgl.Edisi",
          sortable: true
        },
        {
          key: "CustName",
          label: "Nama Agen",
          sortable: true
        },
        {
          key: "salesae_name",
          label: "Sales/AE",
          sortable: true
        },
        {
          key: "area_name",
          label: "Group/Area",
          sortable: true
        },
        {
          key: "kota_name",
          label: "Kota",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },
        {
          key: "kiriman_name",
          label: "Jenis Kiriman",
          sortable: true
        },
        {
          key: "returkonsi",
          label: "Jumlah Retur",
          // thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "createby",
          label: "Input Oleh",
          thStyle: "width:80px",
          thClass: "text-center"
        }
      ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    }
  },
  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },      
  },   
  created: async function() {
    const a = await crud.list({ tablename: "koranjeniskiriman", limit: 1000 });
    this.customer_group = a.reduce((newArr, el, idx) => {
      newArr.push({ value: el.kiriman_code, text: el.kiriman_name });
      return newArr;
    }, [{ value: '', text: "-- Semua Jenis --" }]);
  },
  methods: {
    onSelectKoranCust: function(_selected) {
      this.tblData.customer_id = _selected.customer_id;
      this.tblData.CustName = _selected.CustName;
      this.lkuKoranCustShow = false;
    },
    onSelectKoranSales: function(_selected) {
      this.tblData.salesae_id = _selected.salesae_id;
      this.tblData.salesae_name = _selected.salesae_name;
      this.lkuKoranSalesShow = false;
    },
    // onSelectKoranCollect: function(_selected) {
    //   this.tblData.collector_codename = _selected.crewnik;
    //   this.lkuKoranCollectShow = false;
    // },
    onSelectKota: function(_selected) {
      this.tblData.kota_id = _selected.kota_id;
      this.tblData.kota_name = _selected.kota_name;
      this.lkuKoranKotaShow = false;
    },
    // onSelectJurusan: function(_selected) {
    //   this.tblData.jurusan_id = _selected.jurusan_id;
    //   this.tblData.jurusan_name = _selected.jurusan_name;
    //   this.lkuKoranJurusanShow = false;
    // },
    // data: async function(ctx) {
    //   this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
    //   const list = await koran_kiriman.list(this.tblData);
    //   list.forEach((el, idx) => {
    //     list[idx].tanggal = moment(el.tanggal).format("YYYY-MM-DD");
    //     list[idx].tglretur = moment(el.tglretur).format("YYYY-MM-DD");
    //   });
    //   this.isLoading = false;
    //   return list;
    // },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.returKoran) {
            this.tblData[key] = filter.returKoran[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.returKoran.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          if (!(filter.returKoran.tglR1)) {
            this.tblData.tglR1='';
            this.tblData.tglR2='';
          }
          this.showFilter=filtered;
          delete filter.returKoran;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=false; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await koran_kiriman.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                    this.isLoading=false;
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await koran_kiriman.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                this.isLoading=false;
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
                }
        }
    },       
    saveFilter() {
      const keys = ['customer_id', 'CustName', 'tgl1', 'tgl2', 'tglR1', 'tglR2', 'kota_id', 'kota_name', 'customer_group', 'no_return', 'createby', 'salesae_id', 'salesae_name'];
      let filtered = false;
      const returKoran={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              returKoran[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          returKoran.page=this.tblData.page;
          returKoran.limit=this.tblData.limit;
          returKoran.sortBy=this.tblData.sortBy;
          returKoran.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.returKoran=returKoran;
          this.$store.commit("filter", filter);
      }
    },        
    clearFilter() {
      this.tblData.CustName = '';
      this.tblData.customer_id = '';
      this.tblData.customer_group = '';
      this.tblData.kota_id = '';
      this.tblData.kota_name = '';
      this.tblData.no_return = null;
      this.tblData.tglR1 = '';
      this.tblData.tglR2 = '';
      this.tblData.tgl1 = '';
      this.tblData.tgl2 = '';
    },
    search(ctx) {
      this.tblData.page=1;
      if (this.$refs.table) this.$refs.table.refresh();
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    // rowPrint(record) {
    //   this.rowClicked(record);
    //     this.print();        
    // },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },     
    add: function(data) {
      router.push({ name: "koran.returkirimanfrm" });
    },
    edit: async function(data) {
      if (this.model.returhdrKey) {
        // console.log(moment(this.model.tglretur).format("YYYY-MM-DD"),this.tglaktif)
        if (moment(this.model.tglretur).format("YYYY-MM-DD")<this.tglaktif) {
                toastr.error("Tanggal transaksi sudah CLOSED", "EDIT ERROR MESSAGE",5000);
        } else { 
        router.push({
          name: "koran.returkirimanfrm",
          params: {
            returhdrKey: this.model.returhdrKey,
            tglretur: moment(this.model.tglretur).format("YYYY-MM-DD"),
            customer_id: this.model.customer_id,
            CustCode: this.model.CustCode,
            CustName: this.model.CustName
          }
        });
        }
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    save: async function(callback) {},
    deleteConfirm(item) {
      if (this.model.returhdrKey) {
        if (moment(this.model.tglretur).format("YYYY-MM-DD")<this.tglaktif) {
                toastr.error("Tanggal transaksi sudah CLOSED", "ERROR MESSAGE",10000);
        } else { 
        this.showDelConfirm = true;
        }
      } else {
        toastr.warn("Please select a row that want to be Deleted!");
      }
    },
    deleteData: async function() {
      try {
        await koran_kiriman.remove(this.model);
        toastr.success("Delete record successfully");
        this.refresh();
      } catch (error) {
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    exportxls: async function() {
      this.isLoading = true;
      try {
        const response = await koran_kiriman.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    closeFrm() {
      //   this.showForm = false;
      //   this.showList = true;
    },
    close() {
      router.push({name: "koran.home"});
    }
  }
};
</script>